export default __webpack_public_path__ + "static/media/Fantasy_20.8555fef2.png";